module.exports = __webpack_public_path__ + "static/media/shelter_anchorage_2.3a2b8c71.svg";